import { render, staticRenderFns } from "./destination.vue?vue&type=template&id=16a31064&scoped=true&"
import script from "./destination.vue?vue&type=script&lang=ts&"
export * from "./destination.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a31064",
  null
  
)

export default component.exports